<template>
  <b-row
    align-v="center"
    align-h="between"
    class="hp-sidebar-footer mx-0 hp-bg-color-dark-90"
  >
    <div
      v-if="!collapsed"
      class="divider hp-border-black-40 hp-border-color-dark-70 mt-0 px-0"
    ></div>

    <b-col>
      <b-row align-v="center">
        <div v-if="!collapsed" class="w-auto ml-8 px-0 mt-6">
          <span
            class="d-block hp-text-color-black-100 hp-text-color-dark-0 hp-p1-body lh-1"
          >
            {{ username }}
          </span>

          <b-link
            to="/pages/profile"
            class="hp-badge-text hp-text-color-dark-30 font-weight-normal"
          >
            Настройки профиля
          </b-link>
        </div>
      </b-row>
    </b-col>

    <b-col v-if="!collapsed" class="hp-flex-none w-auto px-0">
      <b-link to="/pages/profile">
        <i
          class="hp-text-color-black-100 hp-text-color-dark-0 ri-settings-3-line"
          style="font-size: 24px"
        ></i>
      </b-link>
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol, BAvatar, BLink } from "bootstrap-vue";
import axios from "axios";

export default {
  props: ["collapsed"],
  data() {
    return {
      username: "???",
    }
  },
  components: {
    BRow,
    BCol,
    BAvatar,
    BLink,
  },
  async mounted() {
    try {
      const { data }  = await axios.get(
        `${process.env.VUE_APP_API_PROTOCOL}://${process.env.VUE_APP_API_HOST}:${process.env.VUE_APP_API_PORT}/api/v1.0/clients/info`
      );
      this.username = data.username
    } catch (e) {
      console.log(e);
    }
  }
};
</script>
